export { TextContentBlockWithFigures } from './TextContentBlockWithFigures';
